export function getCanonicalURL(url: string | undefined, fallback: string) {
	const canonical = url || fallback;
	return canonical.replace(/http:/, 'https:').split('?')[0];
}
